export default {
  startingAt: {
    id: 'us_telco_comparators_offer_comparison_card_starting_at',
    defaultMessage: 'Starting at',
  },
  priceSuffix: {
    id: 'us_telco_comparators_offer_comparison_card_price_suffix',
    defaultMessage: '/ month',
  },
  taxes: {
    id: 'us_telco_comparators_offer_comparison_card_price_taxes_suffix',
    defaultMessage: '+ taxes',
  },
  onTrustpilot: {
    id: 'us_telco_comparators_offer_comparison_card_on_trustpilot',
    defaultMessage: 'on Trustpilot',
  },
  getStarted: {
    id: 'us_telco_comparators_offer_comparison_card_get_started',
    defaultMessage: 'Get started',
  },
  modalTitle: {
    id: 'us_telco_comparators_offer_comparison_card_modal_title',
    defaultMessage: 'How to get your savings',
  },
  seeFullDetails: {
    id: 'us_telco_comparators_offer_comparison_card_see_full_details',
    defaultMessage: 'See full details',
  },
  close: {
    id: 'us_telco_comparators_offer_comparison_card_close',
    defaultMessage: 'Close',
  },
}
